import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Button } from "semantic-ui-react";
import onboard from "../../assets/images/onboard.png";

function Welcome({ next }) {
  return (
    <Container className='bg-basic' fluid>
      <Row className='justify-content-center'>
        {/* <Col>
          <Image src={logo} className='img-fluid' />
        </Col> */}
        <Col lg={4}>
          <Image src={onboard} className='img-fluid' />
        </Col>
      </Row>
      <Row className='justify-content-center'>
        <Col lg={8}>
          <p style={{ fontSize: 20, color: "grey" }}>
            Welcome to <strong>ROLL App</strong>, bringing a revolutionized
            education system in Rwanda using new all-in-one smart student cards.
            Click next to get started
          </p>
        </Col>
      </Row>
      <Button circular content='Next' floated='right' onClick={next} />
    </Container>
  );
}

export default Welcome;
